import mixpanel from 'mixpanel-browser';
import { injectable } from 'inversify';

import container from '@core/di';
import ProfileStore from '@shared/stores/profile';
import Config from '@core/config';

@injectable()
export default class AuditService {
  static diToken = Symbol('track-events-service');
  private profileStore = container.get<ProfileStore>(ProfileStore.diToken);
  private config = container.get<Config>(Config.diToken);

  getUserParams() {
    return {
      email: this.profileStore.profile?.email,
    };
  }

  initialize() {
    const { logsPanelToken } = this.config.get();

    mixpanel.init(logsPanelToken as string, {
      debug: true,
      track_pageview: true,
      persistence: 'localStorage',
    });
  }

  userIdentify = async () => {
    try {
      if (this.profileStore?.profile?.ssoId) {
        mixpanel.identify(this.profileStore.profile.ssoId);
      } else if (!this.profileStore?.profileFetching) {
        const profile = await this.profileStore.current();
        mixpanel.identify(profile.ssoId);
      }
    } catch (e) {
      console.log('userIdentify error', { e });
    }
  };

  getDeviceId() {
    return mixpanel.get_property('$device_id');
  }

  trackEvent<T>(eventName: string, eventData: T): void {
    mixpanel.track(eventName, {
      'User Email': this.getUserParams().email,
      ...eventData,
    });
  }
}
